import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Form, FormGroup, Col, Row, Button, InputGroup, FormControl, ControlLabel, Checkbox, Glyphicon, Modal } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons'

import './style.scss';
import constants from '../../util/constants'
import classHelper from '../../util/class.helper'
import NPSpinnerModal from '../../NPSpinnerModal';
import LoadingSpinner from '../../LoadingSpinner';
import ConfirmationModal from './ConfirmationModal';
import DeleteModal from './DeleteModal';
import GrantsModules from './GrantsModules';

const { API_BASE_URL } = constants;

class Roles extends React.Component {
    constructor(props) {
        super(props);

        this.notOkToSave = this.notOkToSave.bind(this);
        this.toggleRoleSelect = this.toggleRoleSelect.bind(this);
        this.toggleRoleGrant = this.toggleRoleGrant.bind(this);
        this.toggleModalConfirmation = this.toggleModalConfirmation.bind(this);
        this.toggleModalDelete = this.toggleModalDelete.bind(this);
        this.handleRoleCreate = this.handleRoleCreate.bind(this);
        this.handleRoleCopy = this.handleRoleCopy.bind(this);
        this.handleRoleSave = this.handleRoleSave.bind(this);
        this.actionRoleDelete = this.actionRoleDelete.bind(this);
        this.actionRoleSave = this.actionRoleSave.bind(this);
        this.actionRefreshRoles = this.actionRefreshRoles.bind(this);

        this.state = {
            selectedRole: null,
            selectableRoles: [],
            selectedGrants: [],
            selectableGrantModules: [],
            prevRoleName: "",
            prevRoleGrants: [],
            roleName: "",
            roleGrants: [],
            roleId: null,
            confirmationModalShow: false,
            deleteModalShow: false,
            success: null,
            error: null
        } 

        this.axiosCancelSource = axios.CancelToken.source();
        this.apiOptions = { headers: { 'Authorization': 'Bearer ' + this.props.apiToken }, cancelToken: this.axiosCancelSource.token };
    }

    componentDidMount() {
        this.actionRefreshRoles();
    }

    notOkToSave() {
        let grants = this.state.roleGrants.concat(this.state.selectedGrants);

        if (this.state.roleName == '') return true;
        if (grants?.length == 0) return true;
        return false;
    }

    toggleRoleSelect(item) {
        this.setState({
            selectedRole: item ? item : null,
            selectedGrants: item ? item.value.Grants: [],
            prevRoleName: item ? item.label : "",
            roleGrants: item ? item.value.Grants : [],
            roleName: item ? item.label : "",
            roleId: item ? item.value.RoleId : null     
        })
    }

    toggleRoleGrant(event, grant) {
        if (this.state.selectedGrants?.some(g => g.Type == grant.Type)) {
            // Grant exists - remove
            let _selectedGrants = [...this.state.selectedGrants];

            let indexArr = this.state.selectedGrants.map((_grant, index) => _grant.Type === grant.Type ? index : '').filter(String)
            if (indexArr != null) {

                for (let i = indexArr.length - 1; i >= 0; i--)
                    _selectedGrants.splice(indexArr[i], 1)

                this.setState({
                    selectedGrants: _selectedGrants
                })
            }
        }
        else {
            // Grant does not exist - add
            this.setState({
                selectedGrants: [...this.state.selectedGrants, grant]
            })
        }
    }

    toggleModalConfirmation() {
        this.setState(prevState => {
            return {
                ...prevState,
                confirmationModalShow: !prevState.confirmationModalShow
            }
        });
    }

    toggleModalDelete() {
        this.setState(prevState => {
            return {
                ...prevState,
                deleteModalShow: !prevState.deleteModalShow
            }
        });
    }

    handleRoleCreate() {
        this.setState({
            selectedRole: null,
            roleGrants: [],
            roleName: "",
            roleId: null,
            prevRoleName: null,
            selectedGrants: []
        })

        // Set focus on name-field
        ReactDOM.findDOMNode(this.roleNameInput).focus();
    }

    handleRoleCopy() {
        this.setState({           
            prevRoleName: this.state.roleName,
            selectedGrants: this.state.selectedGrants,
            roleName: `${this.state.roleName} - Copied`,
            roleId: null,
        })

        // Set focus on name-field
        ReactDOM.findDOMNode(this.roleNameInput).focus();
    }

    handleRoleSave() {
        if (this.state.roleId) 
            this.toggleModalConfirmation();       
        else 
            this.actionRoleSave();      
    }

    actionRoleSave() {
        let self = this;
        let role = {
            RoleId: self.state.roleId || -1,
            Name: self.state.roleName,
            Grants: self.state.selectedGrants
        };

        if (role.Name == "" || role.Grants.length == 0)
            return;

        axios.post(API_BASE_URL + 'Role/SaveRole', role, self.apiOptions)
            .then(response => {
                this.actionRefreshRoles();
                this.setState({
                    success: true,
                    confirmationModalShow: false
                }, () => setTimeout(() => { this.setState({ success: false }) }, 5000))
            })
            .catch(err => {
                this.setState({
                    error: true,
                    confirmationModalShow: false
                }, () => setTimeout(() => { this.setState({ error: false }) }, 5000))
            })
    }

    actionRoleDelete() {
        let self = this;
        let role = {
            RoleId: self.state.roleId || -1,
            Name: self.state.roleName,
            Grants: self.state.roleGrants
        };

        if (role.Name == "" || role.Grants.length == 0)
            return;
        
        axios.post(API_BASE_URL + 'Role/DeleteRole', role, self.apiOptions)
            .then(response => {
                this.actionRefreshRoles();
                this.setState({
                    success: true,
                    deleteModalShow: false,
                    roleName: "",
                    roleGrants: [],
                    selectedGrants: [],
                    selectedRole: null
                }, () => setTimeout(() => { this.setState({ success: false }) }, 2000))
            })
            .catch(err => {
                this.setState({
                    error: true,
                    deleteModalShow: false
                }, () => setTimeout(() => { this.setState({ error: false }) }, 2000))
            })
    }

    actionRefreshRoles() {
        axios.get(API_BASE_URL + 'Role/GetRoles', this.apiOptions)
            .then(response => {
                this.setState({
                    selectableRoles: response.data.AvailableRoles.map(role => ({ label: role.Name, value: role })),
                    selectableGrantModules: response.data.Modules
                });
            })
    }

    render() {
        return (
            <div>
                <Dialog ref={(el) => { this.dialog = el }} />
                <NPSpinnerModal showModal={this.state.showSpinnerModal} title="saving" content={this.state.modalContent} closeAction={this.close} isLoading={this.state.saveInProgress} />
                <Row>
                    <Col d={12} lg={12}>
                        <h3 style={{ "fontSize": "16px", "fontWeight": "600" }}>Select role</h3>
                    </Col>
                </Row>
                <Row>
                    <Form inline onSubmit={evt => { evt.preventDefault(); }}>
                        <Col md={12} lg={12} >
                            <fieldset className="smaller-inputs">
                                <FormGroup className="select">
                                    <InputGroup>
                                        <Select placeholder="Select role"
                                            searchable={true}
                                            styles={classHelper.dropdownStyleLarge()}
                                            isClearable={true}
                                            options={this.state.selectableRoles}
                                            menuContainerStyle={{ zIndex: 5 }}
                                            value={this.state.selectedMachine}
                                            onChange={(item) => this.toggleRoleSelect(item)} />
                                    </InputGroup>

                                    <Button bsStyle="primary" disabled={this.notOkToSave() || this.state.selectedRole == null} className="btn-sm margin-left-10" onClick={evt => { this.handleRoleCopy() }}>
                                        Copy to new role
                                        </Button>

                                    <Button bsStyle="primary" className="btn-sm margin-left-10" onClick={evt => { this.handleRoleCreate() }}>
                                        Create new role
                                        </Button>
                                </FormGroup>
                            </fieldset>
                        </Col>

                        <Col md={12} lg={12} className="margin-top-10" >
                            <fieldset className="myfieldset smaller-inputs">
                                <legend className="mylegend">Role info</legend>
                                <FormGroup className="select margin-top-10">
                                    <InputGroup bsSize="sm">
                                        <InputGroup.Addon>Role name</InputGroup.Addon>
                                        <FormControl
                                            bsSize="sm"
                                            ref={(input) => { this.roleNameInput = input; }}
                                            componentClass={"input"}
                                            style={{ width: 180 }}
                                            readOnly={false}
                                            tabIndex={false ? -1 : null}
                                            value={this.state.roleName}
                                            title="Role name"
                                            placeholder="Role name"
                                            onChange={(e) => this.setState({ roleName: e.target.value })}
                                        />
                                    </InputGroup>
                                </FormGroup>
                            </fieldset>


                            <GrantsModules selectableGrantModules={this.state.selectableGrantModules}
                                roleGrants={this.state.roleGrants}
                                activeGrants={this.state.selectedGrants}
                                toggleRoleGrant={this.toggleRoleGrant}
                                disabled={false} />

                        </Col>

                        <Col sm={12}>
                            {this.state.success &&
                                <div>
                                    <label><FontAwesomeIcon icon={faCheck} /> Success!</label>
                                </div>
                            }
                            {this.state.error &&
                                <div>
                                    <label className="danger"><FontAwesomeIcon icon={faTimes} /> Error: {this.state.error}</label>
                                </div>
                            }   
                        </Col>

                        <Col sm={12}>
                            <Button bsStyle="primary" disabled={this.notOkToSave()} onClick={this.handleRoleSave}>
                                Save
                            </Button>
                            <Button bsStyle="danger" disabled={this.notOkToSave()} className="margin-left-10" onClick={this.toggleModalDelete}>
                                Delete
                            </Button>
                        </Col>

                    </Form>
                </Row>

                <ConfirmationModal showModal={this.state.confirmationModalShow}
                    toggleModal={this.toggleModalConfirmation}
                    confirmationSave={this.actionRoleSave}
                    prevRoleName={this.state.prevRoleName}
                    roleName={this.state.roleName}
                    roleGrants={this.state.roleGrants}
                    selectedGrants={this.state.selectedGrants} />

                <DeleteModal showModal={this.state.deleteModalShow}
                    toggleModal={this.toggleModalDelete}
                    confirmationDelete={this.actionRoleDelete}
                    prevRoleName={this.state.prevRoleName} />

            </div>
        )
    }
}

export default Roles;